import React from 'react';

const topFive = [
  {
    number: '01',
    name: 'Georgia',
  },
  {
    number: '02',
    name: 'South Carolina',
  },
  {
    number: '03',
    name: 'Florida',
  },
  {
    number: '04',
    name: 'West Virginia',
  },
  {
    number: '05',
    name: 'Mississippi',
  },
];

const bottomFive = [
  {
    number: '46',
    name: 'California',
  },
  {
    number: '47',
    name: 'New York',
  },
  {
    number: '48',
    name: 'Hawaii',
  },
  {
    number: '49',
    name: 'Alaska',
  },
  {
    number: '50',
    name: 'New Jersey',
  },
];

const BusinessPlanHeaderHelper = () => (
  <div>
    <div className="col-md-3 top-section-wrapper">
      <div className="top-section-header">
        Top Five
      </div>
      <div className="top-section-header-text">
        The most entrepreneurial states per 100,000 people
      </div>
      <ul>
        {topFive.map(state =>
          <li key={`${state.name}-${state.number}`}>
            <div className="placement-number">
              {state.number}
            </div>
            <div className="state-name">
              {state.name}
            </div>
          </li>,
        )}
      </ul>
    </div>
    <div className="col-md-3 top-section-wrapper">
      <div className="top-section-header">
        Bottom Five
      </div>
      <div className="top-section-header-text">
        The least entrepreneurial states per 100,000 people
      </div>
      <ul>
        {bottomFive.map(state =>
          <li key={`${state.name}-${state.number}`}>
            <div className="placement-number">
              {state.number}
            </div>
            <div className="state-name">
              {state.name}
            </div>
          </li>,
        )}
      </ul>
    </div>
  </div>
);

export default BusinessPlanHeaderHelper;



// WEBPACK FOOTER //
// ./src-react/UsaMap/headers/BusinessPlanHeaderHelper.jsx